import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../hooks/useAuth";

import { pingService, loginFirebase, markdownToImage, markdownToPDF, htmlToImage, htmlToPDF, logoutUser } from "../services/userService";

export const usePingService = () => {
    const { storeAuthData } = useAuth();
    return useMutation({
        mutationFn: pingService,
        onSuccess: (data) => {
            storeAuthData(data);
        },
    });
};

export const useLoginFirebase = ({ onSuccessCallback }) => {
    const { storeAuthData } = useAuth();
    return useMutation({
        mutationFn: loginFirebase,
        onSuccess: (data) => {
            // console.log(data);
            storeAuthData(data);
            if (onSuccessCallback) {
                onSuccessCallback();
            }
            // Navigate and reload
            window.location.replace("/");
        },
    });
};

export const useLogoutUser = () => {
    const { clearAuthData } = useAuth();
    return useMutation({
        mutationFn: logoutUser,
        onSuccess: () => {
            clearAuthData();
            // Navigate and reload
            window.location.replace("/");
        },
    });
};

export const useMarkdownToImage = () => {
    return useMutation({
        mutationFn: markdownToImage,
    });
};

export const useMarkdownToPDF = () => {
    return useMutation({
        mutationFn: markdownToPDF,
    });
};

export const useHtmlToImage = () => {
    return useMutation({
        mutationFn: htmlToImage,
    });
};

export const useHtmlToPDF = () => {
    return useMutation({
        mutationFn: htmlToPDF,
    });
};